module.exports = __webpack_public_path__ + "static/img/quantijingyin2.defad24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quantijingyin2.png
// module id = htjS
// module chunks = 24